'use strict';exports.__esModule = true;var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _set = require('lodash/set');var _set2 = _interopRequireDefault(_set);
var _clearNumber = require('./clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _formatPhoneNumber = require('../utils/formatPhoneNumber');
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var checkNumber = function checkNumber(value) {return !isNaN(value) ? +value : value;};
var omitLocationKeys = ['isFull', 'isCity', 'isNeighborhood', 'map', 'geocoded', 'city', 'street', 'house', 'key', 'tags', 'post_code', 'polygon', 'en.formatted_address', 'he.formatted_address'];
var omitImagesField = ['thumbnail', 'full', 'relativeAngle', '_id', 'id', 'public_id', 'indexIdentifier', 'uploadInProgress', 'contentType', 'source', 'type', 'name'];
var omitVideosField = ['thumbnail', 'full', 'relativeAngle', 'angle', '_id', 'link', 'public_id', 'indexIdentifier', 'contentType', 'uploadInProgress', 'type', 'name'];
var omitCottageField = ['cottageElevator', 'hasBasement'];
var paymentsConfig = ['paymentsPerYear', 'maintenance', 'tax'];

var generatePropertyDataForPublish = function generatePropertyDataForPublish(fields, config, userData, isPreview, isEdit) {
  var necessaryPayments = paymentsConfig.filter(function (payment) {return config[payment];});

  if (necessaryPayments.indexOf('paymentsPerYear') !== -1) {
    necessaryPayments.splice(necessaryPayments.indexOf('paymentsPerYear'), 1, 'rental');
  }

  var values = Object.assign({}, fields, { payments: (0, _pick2.default)(fields.payments, necessaryPayments) });
  var isCottage = values.property_type === 'cottage';
  var isVilla = values.property_type === 'villa';

  if (!isCottage && !isVilla) {
    values = Object.assign({}, (0, _omit2.default)(values, omitCottageField));
  } else {
    values = Object.assign({}, (0, _omit2.default)(values, ['elevators']));
  }var _values =















  values,area = _values.area,price = _values.price,section = _values.section,search_option = _values.search_option,sub_option = _values.sub_option,property_type = _values.property_type,rooms = _values.rooms,floor = _values.floor,address = _values.address,contacts = _values.contacts,images = _values.images,videos = _values.videos,currency = _values.currency;

  var optionType = sub_option === _constants.optionTypes['rent-short'] ? sub_option : search_option;

  var additionalFields = ['construction_year', 'only_part', 'bathrooms', 'toilets', 'balconies', 'balconies_area'];
  if (!isCottage && !isVilla) {
    additionalFields = [].concat(additionalFields, ['elevators']);
  }

  var additionalInfo = { rooms: rooms, floor: floor };

  if ((isCottage || isVilla) && (!floor.out_of || floor.out_of < floor.on_the)) {
    additionalInfo.floor.out_of = floor.on_the;
  }

  if (property_type === 'land') {
    additionalInfo.floor = { on_the: 0, out_of: 1 };
    additionalInfo.rooms = undefined;
  }

  if (values.hasBasement) {
    additionalInfo.hasBasement = values.hasBasement;
  }
  var createField = function createField(field) {
    if (!additionalInfo[field]) {
      additionalInfo[field] = {};
    }
  };

  additionalInfo.area = {};
  additionalInfo.area.base = area.base;
  config.fieldArea && (additionalInfo.area.field = area.field || null);
  config.gardenArea && (additionalInfo.area.garden = area.garden || null);

  var formatDeepFields = function formatDeepFields(field) {
    if (values[field]) {
      Object.keys(values[field]).forEach(function (key) {
        if (values[field][key] !== null) {
          createField(field);
          var value = field === 'payments' ? (0, _clearNumber2.default)(values[field][key]) : values[field][key];
          if (field === 'payments' && value === '') {
            additionalInfo[field][key] = 0;
          } else {
            additionalInfo[field][key] = value !== '' ? checkNumber(value) : null;
          }
        }return additionalInfo;
      });
    }
  };

  var deepFields = ['parking', 'payments'];
  deepFields.forEach(function (field) {return formatDeepFields(field);});

  Object.keys(values).map(function (field) {
    if (values[field]) {
      if (additionalFields.indexOf(field) !== -1) {
        if (field === 'balconies_area') {
          additionalInfo[field] = (values[field].length &&
          values[field].filter(function (item) {return item;})).length ? values[field].map(function (item) {return +item;}) : null;
        } else {
          additionalInfo[field] = checkNumber(values[field]);
        }
      }
    }
    return additionalInfo;
  });

  if (values.entry_date) {
    Object.keys(values.entry_date).forEach(function (key) {
      createField('entry_date');
      var dateValue = values.entry_date[key] ? values.entry_date[key] : '';
      additionalInfo.entry_date[key] = key !== 'date' ? !!values.entry_date[key] : dateValue;
    });
  }

  if (values.light_direction) {
    createField('light_direction');
    Object.keys(values.light_direction).forEach(function (side) {
      additionalInfo.light_direction[side] = !!values.light_direction[side];
    });
  }

  var notRequiredFields = ['description', 'commodities'];
  var notRequired = {};

  notRequiredFields.forEach(function (field) {
    if (values[field]) {
      notRequired[field] = values[field];
    }return notRequired;
  });

  // if (values.commodities) { TODO: in the future will be elevator in cottage
  //   const index = values.commodities.indexOf('elevator');
  //   if (isCottage && index !== -1) {
  //     values.commodities.splice(index, 1);
  //   }
  // }

  var transformContact = function transformContact(type) {
    var email = contacts[type].email;
    var emailField = {};
    if (email === '' && isEdit) {
      emailField.email = null;
    }
    if (email) {
      emailField.email = email.toLowerCase();
    }
    var contact = (0, _omit2.default)(Object.assign({},
    contacts[type], {
      phone: contacts[type].phone ? (0, _formatPhoneNumber.addPhoneCode)(contacts[type].phone.replace(/\D/g, '')) : null }),
    ['realtor_image', 'agency_page', 'realtor_page', 'email']);
    return Object.assign({}, contact, emailField);
  };


  var publishingContacts = { primary: transformContact('primary') };

  if (contacts.secondary) {
    if (contacts.secondary.phone) {
      publishingContacts.secondary = transformContact('secondary');
    } else {
      publishingContacts.secondary = Object.assign({}, contacts.secondary);
    }

    if (contacts.secondary.email === '') {
      publishingContacts.secondary.email = null;
    }
  } else {
    publishingContacts.secondary = null;
  }

  var isAgent = userData.is_agent;

  if (isAgent) {
    publishingContacts.primary.company_name = userData.agent_data.company_name;
  }

  var realtorProperty = isPreview && isAgent ? { realtor_property: isAgent } : {};

  _constants.language.ignoredLanguages.forEach(function (lang) {return (0, _set2.default)(address, lang, null);});

  var setUndefinedIfEmpty = function setUndefinedIfEmpty(obj, key) {
    obj[key] = obj[key] || undefined;
  };

  ['en', 'he'].forEach(function (lang) {
    setUndefinedIfEmpty(address[lang], 'neighborhood');
    setUndefinedIfEmpty(address[lang], 'street_name');
  });

  return Object.assign(
  {
    address: isPreview || !address.place_id ? (0, _omit2.default)(address, omitLocationKeys) : undefined,
    place_id: !isPreview ? address.place_id : undefined,
    hide_house_number: address.place_id ? address.hide_house_number : undefined }, {

    additional_info: additionalInfo,
    vr_link: values.vr_link,
    price: +(0, _clearNumber2.default)(price),
    images: images && images.map(function (item) {return (0, _omit2.default)(item, omitImagesField);}).filter(function (item) {return !!item.link;}),
    videos: videos && videos.map(function (item) {return (0, _omit2.default)(item, omitVideosField);}).filter(function (item) {return !!item.id;}),
    section: section,
    search_option: optionType,
    property_type: property_type,
    contacts: publishingContacts,
    currency: currency },
  realtorProperty,
  notRequired);

};exports.default =

generatePropertyDataForPublish;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/generatePropertyDataForPublish.js
// module id = 1242
// module chunks = 0